import * as GC from '@grapecity/spread-sheets';
import { INotification, NotificationCalibrationTypes } from '@models/notification/notification';
import { autofitColumns } from '@shared/spread/sheet-functions';
import { FONT_NAME, FONT_SIZE } from '@shared/spread/spread-settings';

export const notificationWorkbookInit = args => {
  const spread: GC.Spread.Sheets.Workbook = args.spread;
  return spread;
};

export const setUpNotificationWorkbook = (spread: GC.Spread.Sheets.Workbook, sheet: GC.Spread.Sheets.Worksheet) => {
  sheet.name('Notification');
  sheet.options.allowCellOverflow = true;
  spread.options.tabStripVisible = false;
  spread.options.autoFitType = GC.Spread.Sheets.AutoFitType.cell;
  spread.options.scrollbarMaxAlign = true;
  // Lock spread sheet for changes
  sheet.options.isProtected = true;
  sheet.options.protectionOptions = {
    ...sheet.options.protectionOptions,

    allowSelectLockedCells: true,
    allowSelectUnlockedCells: true,
    allowResizeColumns: true,
    allowSort: true, 
    allowFilter: true,
    allowEditObjects: false,
    allowResizeRows: false,
    allowDragInsertRows: false,
    allowDragInsertColumns: false,
    allowInsertRows: false,
    allowInsertColumns: false,
    allowDeleteRows: false,
    allowDeleteColumns: false
  };
};

export const populateNotificationSpread = (
  spread: GC.Spread.Sheets.Workbook,
  sheet: GC.Spread.Sheets.Worksheet,
  notifications: INotification[]
) => {
  sheet.suspendPaint();
  sheet.suspendEvent();

  // Clear sheet
  const fullRange = sheet.getRange(0, 0, sheet.getRowCount(), sheet.getColumnCount());
  fullRange.clear(GC.Spread.Sheets.StorageType.data);
  fullRange.clear(GC.Spread.Sheets.StorageType.style);

  setHeaders(sheet);

  // Populate main data
  notifications.forEach((notification: INotification, index: number) => {
    sheet.getCell(index, 0).text(notification.ProductName);
    sheet.getCell(index, 1).text(notification.ProductMnemonic);
    sheet.getCell(index, 2).text(NotificationCalibrationTypes[notification.CalibrationType]);
    if (notification.CalibrationType !== 'RECALCULATION') {
      sheet.getCell(index, 3).text(notification.CalibrationRecordStatus);
    }
    sheet.getCell(index, 4).text(notification.Description);
    sheet.getCell(index, 5).value(notification.DateTimeCreated);
  });

  // Set styling
  setNotificationSheetStyling(sheet, notifications);
  setColFilters(spread, sheet);

  sheet.resumePaint();
  sheet.resumeEvent();
};

const setHeaders = (sheet: GC.Spread.Sheets.Worksheet) => {
  // sheet.getCell(0, 0, GC.Spread.Sheets.SheetArea.colHeader).text('Product Name');
  // sheet.getCell(0, 1, GC.Spread.Sheets.SheetArea.colHeader).text('Mnemonic');
  // sheet.getCell(0, 2, GC.Spread.Sheets.SheetArea.colHeader).text('Type');
  // sheet.getCell(0, 3, GC.Spread.Sheets.SheetArea.colHeader).text('Status');
  // sheet.getCell(0, 4, GC.Spread.Sheets.SheetArea.colHeader).text('Message');
  // sheet.getCell(0, 5, GC.Spread.Sheets.SheetArea.colHeader).text('Date Time Created');

  const headers = ['Product Name', 'Mnemonic', 'Type', 'Status', 'Message', 'Date Time Created'];
  headers.forEach((h, i) => {
    sheet.getCell(0, i, GC.Spread.Sheets.SheetArea.colHeader).text(h);
  });
};

const setNotificationSheetStyling = (sheet: GC.Spread.Sheets.Worksheet, notifications: INotification[]) => {
  sheet.setRowCount(notifications.length);
  sheet.setColumnCount(6);

  const fullRange = sheet.getRange(0, 0, sheet.getRowCount(), sheet.getColumnCount());
  fullRange
    .vAlign(GC.Spread.Sheets.VerticalAlign.center)
    .cellPadding(`0 ${parseInt(FONT_SIZE, 10) / 2}`)
    .wordWrap(true)
    .font(`${parseInt(FONT_SIZE, 10)}pt ${FONT_NAME}`);

  const colHeader = sheet.getRange(0, 0, 1, sheet.getColumnCount(), GC.Spread.Sheets.SheetArea.colHeader);
  colHeader.font(`bold ${FONT_SIZE}pt ${FONT_NAME}`);

  autofitColumns(sheet, 0, 6);
  sheet.setColumnWidth(4, 800);
};

const setColFilters = (spread: GC.Spread.Sheets.Workbook, sheet: GC.Spread.Sheets.Worksheet) => {
  const hideRowFilter = new GC.Spread.Sheets.Filter.HideRowFilter(
    new GC.Spread.Sheets.Range(0, 0, sheet.getRowCount(), sheet.getColumnCount())
  );

  sheet.rowFilter(hideRowFilter);
};
